// extracted by mini-css-extract-plugin
module.exports = {"AppleButton":"AppleButton-1-XBP","Icon":"Icon-24BTf","Children":"Children-2Wn6p","Loading":"Loading-2eCTP"};